import { faExclamation, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ROLE_GROUPS, ROLES } from '@moal/api'
import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { AuthenticationContext } from '../../../context/authenticationContext'
import { getRoles } from '../../../utils/APIs/roles'
import { putUserMod } from '../../../utils/APIs/users'
import { toastError, toastSuccess } from '../../../utils/toast'

const ChangeRoleForm = ({ user }) => {
  const { user: staff } = useContext(AuthenticationContext)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [newRole, setNewRole] = useState()

  const [roles, setRoles] = useState()

  useEffect(() => {
    loadRoles()
  }, [])

  useEffect(() => {
    setNewRole(user.role._id)
  }, [user])

  const loadRoles = async () => {
    setLoading(true)
    const response = await getRoles()
    if (response && response.status === 200) {
      if (staff.role.role === ROLES.ADMIN) {
        setRoles(response.data)
      } else {
        setRoles(
          response.data.filter(
            (role) => role.role !== ROLES.BOT && role.role !== ROLES.ADMIN
          )
        )
      }
    } else {
      setError(true)
    }
    setLoading(false)
  }

  const handleSubmitRoleChange = async (e) => {
    e.preventDefault()
    setLoading(true)
    const response = await putUserMod(user._id, 'role', newRole)
    if (response && response.status === 200) {
      toastSuccess('Role changed.')
    } else {
      setError(true)
      toastError('Error changing role.')
    }
    setLoading(false)
  }

  const ROLE_ORDER = ROLE_GROUPS.ALL
  const ROLE_RANK = new Map(ROLE_ORDER.map((role, index) => [role, index]))
  const getRoleRank = (role) =>
    ROLE_RANK.has(role) ? ROLE_RANK.get(role) : Infinity

  return (
    <div className="mb-auto flex flex-col gap-2">
      {user && roles && (
        <form
          onSubmit={handleSubmitRoleChange}
          autoComplete="off"
          className="flex gap-2"
        >
          <div className="relative flex flex-grow focus-within:z-10 gap-2 items-center">
            <select
              value={newRole}
              onChange={(e) => setNewRole(e.target.value)}
              className="grow input"
            >
              {[...roles]
                .sort((a, b) => getRoleRank(a.role) - getRoleRank(b.role))
                .map((role) => (
                  <option key={role._id} value={role._id}>
                    {role.role}
                  </option>
                ))}
            </select>
            <button
              type="submit"
              aria-label="Submit Role"
              className="button-confirm"
            >
              Change Role
            </button>
          </div>
        </form>
      )}
      {loading && (
        <div className="flex items-center whitespace-nowrap bg-green-500 px-4 py-2 font-bold text-white transition-all hover:bg-green-600 active:bg-green-700">
          <FontAwesomeIcon
            className="mr-2 h-5 cursor-pointer"
            icon={faSpinner}
            spin
          />
        </div>
      )}
      {error && (
        <div className="flex items-center whitespace-nowrap bg-red-500 px-4 py-2 font-bold text-white transition-all hover:bg-red-600 active:bg-red-700">
          <FontAwesomeIcon
            className="mr-2 h-5 cursor-pointer"
            icon={faExclamation}
          />
        </div>
      )}
    </div>
  )
}

ChangeRoleForm.propTypes = {
  user: PropTypes.object.isRequired
}

export default ChangeRoleForm
